function processResponseBody(response) {
    const contentType = response.headers.get('content-type');
    if (contentType) {
        if (contentType.indexOf('application/json') !== -1) {
            return response.json();
        }
    }
    return Promise.resolve();
}

export function apiHandleResponse(response) {
    return processResponseBody(response)
        .then((payload) => {
            if (response.ok) {
                return payload;
            }

            // eslint-disable-next-line no-throw-literal
            throw { response, payload };
        });
}

export async function apiHandleNDJsonResponse(response) {
    if (!response.ok) {
        // Try to read error payload as text
        let errorPayload;
        try {
            errorPayload = await response.text();
        } catch {
            errorPayload = null;
        }
        // eslint-disable-next-line no-throw-literal
        throw { response, payload: errorPayload };
    }

    const contentType = response.headers.get('content-type');
    if (!contentType || !contentType.includes('application/x-ndjson')) {
        // Not an NDJSON response
        return [];
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let buffer = '';
    const results = [];

    while (true) {
        const { value, done } = await reader.read();
        if (done) break;
        buffer += decoder.decode(value, { stream: true });

        let lines = buffer.split('\n');
        buffer = lines.pop(); // last line may be incomplete

        for (const line of lines) {
            if (line.trim()) {
                try {
                    results.push(JSON.parse(line));
                } catch (e) {
                    // Optionally handle parse error
                }
            }
        }
    }
    // Handle any remaining buffered data
    if (buffer.trim()) {
        try {
            results.push(JSON.parse(buffer));
        } catch (e) {
            // Optionally handle parse error
        }
    }
    return results;
}

export function apiHandleOctetResponse(response) {
    if (response.ok) {
        return response.blob();
    }

    return false;
}

export function apiHandleOctetResponseWithFileName(response) {
    if (response.ok) {
        var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        const disposition = response.headers.get('content-disposition');
        let fileName = '';
        var matches = filenameRegex.exec(disposition);
        if (matches != null && matches[1]) {
            fileName = matches[1].replace(/['"]/g, '');
        }

        return response.blob().then((file) => {
            return {
                file,
                fileName,
            }
        });
    }

    return false;
}